import {createBrowserHistory} from 'history';

//import PiwikReactRouter from 'piwik-react-router';
import {ROUTE_BASENAME} from './config';

//const piwik = PiwikReactRouter({
//	url: 'https://piwik.braunschweig.de',
//	siteId: 14,
//});

export default createBrowserHistory({basename: ROUTE_BASENAME}); // piwik.connectToHistory(...);
